import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {normalizeStyles, typographyStyles} from '@webs/components-library/theming';

@customElement('webs-footer-menu-column')
export class FooterMenuColumn extends LitElement {

  static styles = [
    normalizeStyles,
    typographyStyles,
    css`

      p {
        color: var(--color-light-grey);
        font-size: 1rem;
        font-family: var(--font-family-heading);
        font-weight: var(--font-weight-base);
        margin: 0 0  1.6rem;
      }

      ::slotted(*) {
        margin-bottom: 1.2rem;
      }
      ::slotted(*:last-child) {
        margin-bottom: 0;
      }
    `
  ];

  @property()
  title: string;

  protected render(): unknown {
    return html`
      ${this.title ? html`<p>${this.title}</p>` : ''}
      <slot></slot>
    `;
  }
}
